import './TrialLinkActivation.sass';

import React, { FC } from 'react';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { useDispatch, useSelector } from 'react-redux';
import { trialLinksActions, trialLinksInfoSelector } from '$store/trialLinks';
import { UnitName, UnitPhoto } from '$shared/components';
import { useTranslator, useUserInfo } from '$hooks';
import { BottomBar, Button } from '$uikit';
import { authSelector } from '$store/auth';
import { useRoute } from 'react-router5';
import { AUTH_REQUIRED } from '$shared/constants/pages';
import { setStorageItem } from '$utils';

const TrialLinkActivationComponent: FC<{
  info: {
    hash: string;
    userId: number;
    days: number;
  };
}> = ({ info }) => {
  const t = useTranslator();
  const user = useUserInfo(info.userId || 0);
  const { router } = useRoute();
  const dispatch = useDispatch();
  const { isLogged } = useSelector(authSelector);

  const handleActivate = () => {
    dispatch(trialLinksActions.activate());
  };

  const handleAuth = () => {
    setStorageItem('trialLink', info.hash);
    dispatch(trialLinksActions.clearInfo());
    router.navigate(AUTH_REQUIRED);
  };
  const handleClose = () => {
    dispatch(trialLinksActions.clearInfo());
  };

  return (
    <BottomSheet scroll={false} onClose={handleClose} className="TrialLinkActivation">
      <div className="TrialLinkActivation__user">
        <UnitPhoto size="story" unit={user} />
        <UnitName unit={user} />
      </div>
      <div className="TrialLinkActivation__title">
        {t('trial_links_activation_title', {
          count: info.days,
        })}
      </div>
      <div className="TrialLinkActivation__description">
        {t('trial_links_activation_desc_paid', { price: '€1' })}
      </div>
      <BottomBar>
        {!isLogged ? (
          <Button onClick={handleAuth}>
            {t('trial_links_activation_button_activate')}
          </Button>
        ) : (
          <Button onClick={handleActivate}>
            {t('trial_links_activation_button_pay', { price: '€1' })}
          </Button>
        )}
      </BottomBar>
    </BottomSheet>
  );
};

export const TrialLinkActivation: FC = () => {
  const info = useSelector(trialLinksInfoSelector);
  if (info) {
    return <TrialLinkActivationComponent info={info} />;
  } else {
    return null;
  }
};
